import { graphql } from 'react-relay';

export default graphql`
  query AdminPage_Query {
    viewer {
      id
      id
      ...AdminPage_viewer
    }
  }
`;
